var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 750,
    height: 466,
    viewBox: "0 0 750 466",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ilus-4",
    clipPath: "url(#clip0_386_456)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M510.2 223.03H232.18C221.725 223.03 213.25 231.505 213.25 241.96V389.09C213.25 399.545 221.725 408.02 232.18 408.02H510.2C520.655 408.02 529.13 399.545 529.13 389.09V241.96C529.13 231.505 520.655 223.03 510.2 223.03Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M420.92 341.01H318.13C314.987 341.01 312.44 343.558 312.44 346.7V389.24C312.44 392.382 314.987 394.93 318.13 394.93H420.92C424.062 394.93 426.61 392.382 426.61 389.24V346.7C426.61 343.558 424.062 341.01 420.92 341.01Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M183.29 62.1699H105.24V131.85H183.29V62.1699Z",
    fill: "white",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M105.24 71.54H183.29",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M135.77 113.99L152.75 81.3899",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M156.7 83.8198L170.34 98.2198L156.68 110.22",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M131.82 110.22L118.18 98.1998L131.84 83.8198",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M195.1 173.63H74.85V298.71H195.1V173.63Z",
    fill: "white",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M75.23 185.91H195.1",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M84.41 195.91H101.06",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M106.83 195.91H138.07",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M143.88 195.96H179.03",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M87.86 207.05H104.49",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M115.67 207.05H146.9",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M91.3 218.2H105.04",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M113.53 218.2H152.13",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M94.77 229.34H111.37",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M114.18 229.34H159.73",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M163.74 229.34H185.52",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M90.86 240.48H107.47",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M111.18 240.48H136.76",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M143.88 240.48H169.27",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M90.86 251.72H97.85",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M104.54 251.72H135.43",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M138.32 251.72H148.69",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M90.86 262.76H100.73",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M106.29 262.76H141.8",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M145.8 262.76H162.41",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M87.42 273.91H97.21",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M104.27 273.91H139.79",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M142.69 273.91H159.04",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M87.42 285.05H104.02",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M112.07 285.05H124.54",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M127.44 285.05H155.08",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M510.2 38.04H232.18C221.725 38.04 213.25 46.5153 213.25 56.97V204.1C213.25 214.555 221.725 223.03 232.18 223.03H510.2C520.655 223.03 529.13 214.555 529.13 204.1V56.97C529.13 46.5153 520.655 38.04 510.2 38.04Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M498.23 236.11H244.08C237.138 236.11 231.51 241.738 231.51 248.68V315.83C231.51 322.772 237.138 328.4 244.08 328.4H498.23C505.172 328.4 510.8 322.772 510.8 315.83V248.68C510.8 241.738 505.172 236.11 498.23 236.11Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M516.02 53.74H228.95V208.19H516.02V53.74Z",
    fill: "#E8E4EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M228.95 72.5H516.03",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M251.14 72.5V208.19",
    stroke: "#8F72AC",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M260.22 82.3799H302.56",
    stroke: "#E24473",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M313.11 82.3799H327.84",
    stroke: "#620C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M334.9 82.3799H363.81",
    stroke: "#620C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M239.9 66.8901C242.186 66.8901 244.04 65.0366 244.04 62.7501C244.04 60.4636 242.186 58.6101 239.9 58.6101C237.614 58.6101 235.76 60.4636 235.76 62.7501C235.76 65.0366 237.614 66.8901 239.9 66.8901Z",
    fill: "#B2A1C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M239.13 86.2499C240.875 86.2499 242.29 84.8351 242.29 83.0899C242.29 81.3447 240.875 79.9299 239.13 79.9299C237.385 79.9299 235.97 81.3447 235.97 83.0899C235.97 84.8351 237.385 86.2499 239.13 86.2499Z",
    fill: "#CFC5D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M239.13 97.6999C240.875 97.6999 242.29 96.2851 242.29 94.5399C242.29 92.7947 240.875 91.3799 239.13 91.3799C237.385 91.3799 235.97 92.7947 235.97 94.5399C235.97 96.2851 237.385 97.6999 239.13 97.6999Z",
    fill: "#CFC5D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M239.13 109.15C240.875 109.15 242.29 107.735 242.29 105.99C242.29 104.245 240.875 102.83 239.13 102.83C237.385 102.83 235.97 104.245 235.97 105.99C235.97 107.735 237.385 109.15 239.13 109.15Z",
    fill: "#CFC5D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M239.13 130.49C240.875 130.49 242.29 129.075 242.29 127.33C242.29 125.585 240.875 124.17 239.13 124.17C237.385 124.17 235.97 125.585 235.97 127.33C235.97 129.075 237.385 130.49 239.13 130.49Z",
    fill: "#CFC5D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M239.13 141.94C240.875 141.94 242.29 140.525 242.29 138.78C242.29 137.035 240.875 135.62 239.13 135.62C237.385 135.62 235.97 137.035 235.97 138.78C235.97 140.525 237.385 141.94 239.13 141.94Z",
    fill: "#CFC5D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M239.13 153.39C240.875 153.39 242.29 151.975 242.29 150.23C242.29 148.485 240.875 147.07 239.13 147.07C237.385 147.07 235.97 148.485 235.97 150.23C235.97 151.975 237.385 153.39 239.13 153.39Z",
    fill: "#CFC5D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M239.13 173.38C240.875 173.38 242.29 171.965 242.29 170.22C242.29 168.475 240.875 167.06 239.13 167.06C237.385 167.06 235.97 168.475 235.97 170.22C235.97 171.965 237.385 173.38 239.13 173.38Z",
    fill: "#CFC5D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M239.13 184.83C240.875 184.83 242.29 183.415 242.29 181.67C242.29 179.925 240.875 178.51 239.13 178.51C237.385 178.51 235.97 179.925 235.97 181.67C235.97 183.415 237.385 184.83 239.13 184.83Z",
    fill: "#CFC5D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M239.13 196.28C240.875 196.28 242.29 194.865 242.29 193.12C242.29 191.375 240.875 189.96 239.13 189.96C237.385 189.96 235.97 191.375 235.97 193.12C235.97 194.865 237.385 196.28 239.13 196.28Z",
    fill: "#CFC5D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M254.3 66.8901C256.586 66.8901 258.44 65.0366 258.44 62.7501C258.44 60.4636 256.586 58.6101 254.3 58.6101C252.013 58.6101 250.16 60.4636 250.16 62.7501C250.16 65.0366 252.013 66.8901 254.3 66.8901Z",
    fill: "#B2A1C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M268.71 66.8901C270.996 66.8901 272.85 65.0366 272.85 62.7501C272.85 60.4636 270.996 58.6101 268.71 58.6101C266.423 58.6101 264.57 60.4636 264.57 62.7501C264.57 65.0366 266.423 66.8901 268.71 66.8901Z",
    fill: "#B2A1C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M260.22 94.54H289.58",
    stroke: "#620C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M298.4 94.54H413.91",
    stroke: "#620C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M420.98 94.54H478.5",
    stroke: "#620C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M260.22 106.12H361.62",
    stroke: "#620C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M370.58 106.12H406.7",
    stroke: "#E24473",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M260.22 127.12H275.95",
    stroke: "#620C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M284.6 127.12H321.42",
    stroke: "#620C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M260.22 137.93H291.53",
    stroke: "#620C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M298.4 137.93H357.27",
    stroke: "#620C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M363.39 137.93H396.1",
    stroke: "#620C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M260.22 149.52H303.94",
    stroke: "#620C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M312.91 149.52H384.52",
    stroke: "#620C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M392.58 149.52H450.7",
    stroke: "#620C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M260.22 170.22H303.94",
    stroke: "#E24473",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M312.16 170.22H328.81",
    stroke: "#620C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M334 170.22H365.31",
    stroke: "#620C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M260.22 181.02H289.74",
    stroke: "#620C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M297.21 181.02H414.21",
    stroke: "#620C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M420.98 181.02H482.08",
    stroke: "#E24473",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M675.73 65.5601H555.03V243.49H675.73V65.5601Z",
    fill: "white",
    stroke: "#B2A1C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M610.52 87.49H570.24V109.85H610.52V87.49Z",
    stroke: "#B2A1C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M610.52 148.57H570.24V170.93H610.52V148.57Z",
    stroke: "#B2A1C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M639.19 204.84H598.91V227.2H639.19V204.84Z",
    stroke: "#B2A1C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M664.24 137.37H623.96V159.73H664.24V137.37Z",
    stroke: "#B2A1C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M555.03 77.3H675.71",
    stroke: "#B2A1C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M590.31 109.86V148.09",
    stroke: "#B2A1C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M644.1 136.97V126.76",
    stroke: "#B2A1C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M590.38 126.76H644.1",
    stroke: "#B2A1C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M590.31 170.93V189.37",
    stroke: "#B2A1C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M620.65 204.38V189.37",
    stroke: "#B2A1C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M590.31 189.37H620.65",
    stroke: "#B2A1C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M610.4 362.58C637.202 362.58 658.93 340.852 658.93 314.05C658.93 287.248 637.202 265.52 610.4 265.52C583.598 265.52 561.87 287.248 561.87 314.05C561.87 340.852 583.598 362.58 610.4 362.58Z",
    fill: "white",
    stroke: "#4B096F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M610.4 343.3C627.278 343.3 640.96 329.618 640.96 312.74C640.96 295.862 627.278 282.18 610.4 282.18C593.522 282.18 579.84 295.862 579.84 312.74C579.84 329.618 593.522 343.3 610.4 343.3Z",
    stroke: "#4B096F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M610.4 337.74C624.207 337.74 635.4 326.547 635.4 312.74C635.4 298.933 624.207 287.74 610.4 287.74C596.593 287.74 585.4 298.933 585.4 312.74C585.4 326.547 596.593 337.74 610.4 337.74Z",
    fill: "#620C90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M629.71 336.41L633.24 342.51C634.57 344.82 633.77 347.76 631.48 349.09C629.19 350.42 626.25 349.62 624.92 347.33L621.41 341.24",
    stroke: "#4B096F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M201.95 467.84L243.75 391.89L315.78 415.83L295.33 482.72L201.95 467.84Z",
    fill: "#CA3C66"
  }), /*#__PURE__*/React.createElement("g", {
    id: "04_lineas"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M260.22 193.1H363.81",
    stroke: "#E24473",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M370.58 193.1H403.7",
    stroke: "#E24473",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "04_palma_izq",
    d: "M324.53 390.5C324.04 391.03 323.55 391.54 323.03 392.06C313.53 401.53 306.71 413.01 306.71 413.01L251.52 394.93C253.86 392.18 262.33 379.48 262.33 379.48C267.72 374.99 266.2 348.15 266.2 348.15C266.2 348.15 264.21 329.49 265.05 312.12C265.38 317.28 267.35 305 273.5 305C277.64 305 277 317.5 279.94 312.84H280.04C281 318 281.35 308 287 308C290.01 308 289.5 321.5 291.56 318.89C293 322 294.57 309.51 299 310C302.65 310.41 303 319.5 305.19 315.65C307 319.5 306.13 309.5 314.5 309.5C319 309.5 320.34 319.09 321.98 314.18C319.98 328.59 321.8 347.92 323.49 351.18C323.15 351.42 323 391.61 324.53 390.5Z",
    fill: "#E8E4EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "04_medio_izq",
    d: "M320.4 274.6C314.74 283.82 308.08 304.7 306.38 310.15C306.37 310.17 306.37 310.18 306.37 310.19C306.35 310.27 306.33 310.35 306.31 310.42C306.31 310.36 306.34 310.3 306.37 310.24C306.31 310.62 306.24 311.02 306.16 311.45C305.94 312.71 305.62 314.17 305.19 315.65C303.85 320.36 301.49 325.28 297.84 324.87C293.41 324.38 291.83 321.83 291.56 318.89C291.54 318.75 291.54 318.6 291.53 318.45C291.53 318.14 291.53 317.82 291.53 317.5C291.61 314.71 292.61 311.81 293.28 310.17C293.37 309.96 293.45 309.75 293.53 309.56C293.74 309.08 293.88 308.81 293.88 308.81H293.84C293.89 308.68 293.94 308.57 293.99 308.46L293.91 308.73C293.97 308.59 294.09 308.29 294.27 307.84C294.27 307.83 294.27 307.82 294.27 307.82C296.38 302.66 306.13 278.9 310.17 274.08C314.46 268.97 317.83 267.91 319.86 269.73C321.14 270.88 321.29 273.13 320.39 274.6H320.4Z",
    fill: "#E8E4EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "04_indice_izq",
    d: "M325.9 302.14C324.82 304.14 323.93 306.4 323.24 308.82C322.73 310.53 322.31 312.33 321.98 314.18C320.34 319.09 317.41 324.87 314.59 324.87C306.22 324.87 304.97 319.58 305.19 315.65C305.62 314.17 305.94 312.71 306.16 311.45C306.24 311.02 306.31 310.62 306.37 310.24C311.21 295.63 330.47 270.9 334.36 273.78C339.77 277.8 334.73 285.9 325.9 302.14V302.14Z",
    fill: "#E8E4EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "04_pulgar_izq",
    d: "M344.51 322.71C339.86 321.76 332.73 339.12 332.73 339.12C332.73 339.12 326.24 351.17 323.98 351.55C323.83 351.58 323.66 351.44 323.5 351.17C323.16 351.42 322.81 351.66 322.47 351.92C320.61 353.34 318.88 354.93 317.34 356.69C315.87 358.36 314.58 360.19 313.51 362.14C312.45 364.06 311.62 366.09 311.02 368.19C310.41 370.34 310.05 372.56 309.94 374.79C309.82 377.12 309.96 379.46 310.34 381.76C310.62 383.43 310.97 385.09 311.47 386.7C312.01 388.43 312.74 390.27 314.02 391.6C314.55 392.14 315.19 392.58 315.92 392.78C316.61 392.96 317.35 392.89 318.05 392.8C325.27 391.89 326.75 388.32 329.76 384.36C330.66 383.17 331.53 381.95 332.36 380.7C334.02 378.21 335.53 375.61 336.88 372.94C342.35 362.06 348.69 346.36 348.74 331.93C348.74 331.93 349.16 323.66 344.52 322.71H344.51Z",
    fill: "#E8E4EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "04_menique_izq",
    d: "M283.72 278.21C280.89 285.34 280.73 305.05 280.97 307.52C280.98 307.65 280.99 307.73 281.01 307.76C281.01 307.78 281.01 307.8 281.01 307.82C280.97 307.98 280.92 308.2 280.85 308.46C279.87 312.06 278.68 324.9 273.06 324.9C264.52 324.9 264.9 310.21 265.02 307.84C265.03 307.63 265.04 307.52 265.04 307.52C265.43 302.9 266.08 298.51 267.12 294.75C272.3 275.96 277.17 272.4 280.53 272.33C283.88 272.25 283.73 278.21 283.73 278.21H283.72Z",
    fill: "#E8E4EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "04_anular_izq",
    d: "M304.72 270.67L293.89 308.79V308.81C293.89 308.81 291.14 314.31 291.57 318.89C290.24 322.18 288.2 324.87 285.19 324.87C277.52 324.87 280 312.08 280.85 308.46C280.92 308.2 280.97 307.98 281.01 307.82C281.01 307.8 281.01 307.78 281.03 307.77C281.06 307.74 281.07 307.68 281.08 307.57C281.08 307.54 281.08 307.52 281.08 307.52C281.11 307.23 281.14 306.71 281.17 305.91C281.54 296.59 294.24 265.97 300.17 265.49C306.1 265.01 304.72 270.67 304.72 270.67V270.67Z",
    fill: "#E8E4EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "04_palma_der",
    d: "M439.89 389C440.38 389.53 440.87 390.04 441.39 390.56C450.89 400.03 457.71 411.51 457.71 411.51L512.9 393.43C510.56 390.68 502.09 377.98 502.09 377.98C496.7 373.49 498.22 346.65 498.22 346.65C498.22 346.65 500.21 327.99 499.37 310.62C499.04 315.78 496.65 304 490.5 304C486.36 304 486.5 316 484.48 311.34H484.38C484 316 483.15 307 477.5 307C472.5 306.5 474.19 320.68 472.86 317.39C472 319 473 308.5 465.5 309C461.85 309.41 460.57 318.86 459.23 314.15C459.45 318.08 458.87 308.5 450.5 308.5C447.68 308.5 444.5 310.5 442.44 312.68C444.44 327.09 442.62 346.42 440.93 349.68C441.27 349.92 441.42 390.11 439.89 389Z",
    fill: "#E8E4EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "04_medio_der",
    d: "M444.02 273.1C449.68 282.32 456.34 303.2 458.04 308.65C458.05 308.67 458.05 308.68 458.05 308.69C458.07 308.77 458.09 308.85 458.11 308.92C458.11 308.86 458.08 308.8 458.05 308.74C458.11 309.12 458.18 309.52 458.26 309.95C458.48 311.21 458.8 312.67 459.23 314.15C460.57 318.86 462.93 323.78 466.58 323.37C471.01 322.88 472.59 320.33 472.86 317.39C472.88 317.25 472.88 317.1 472.89 316.95C472.89 316.64 472.89 316.32 472.89 316C472.81 313.21 471.81 310.31 471.14 308.67C471.05 308.46 470.97 308.25 470.89 308.06C470.68 307.58 470.54 307.31 470.54 307.31H470.58C470.53 307.18 470.48 307.07 470.43 306.96L470.51 307.23C470.45 307.09 470.33 306.79 470.15 306.34C470.15 306.33 470.15 306.32 470.15 306.32C468.04 301.16 458.29 277.4 454.25 272.58C449.96 267.47 446.59 266.41 444.56 268.23C443.28 269.38 443.13 271.63 444.03 273.1H444.02Z",
    fill: "#E8E4EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "04_indice_der",
    d: "M438.52 300.64C439.6 302.64 440.49 304.9 441.18 307.32C441.69 309.03 442.11 310.83 442.44 312.68C444.08 317.59 447.01 323.37 449.83 323.37C458.2 323.37 459.45 318.08 459.23 314.15C458.8 312.67 458.48 311.21 458.26 309.95C458.18 309.52 458.11 309.12 458.05 308.74C453.21 294.13 433.95 269.4 430.06 272.28C424.65 276.3 429.69 284.4 438.52 300.64V300.64Z",
    fill: "#E8E4EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "04_pulgar_der",
    d: "M419.91 321.21C424.56 320.26 431.69 337.62 431.69 337.62C431.69 337.62 438.18 349.67 440.44 350.05C440.59 350.08 440.76 349.94 440.92 349.67C441.26 349.92 441.61 350.16 441.95 350.42C443.81 351.84 445.54 353.43 447.08 355.19C448.55 356.86 449.84 358.69 450.91 360.64C451.97 362.56 452.8 364.59 453.4 366.69C454.01 368.84 454.37 371.06 454.48 373.29C454.6 375.62 454.46 377.96 454.08 380.26C453.8 381.93 453.45 383.59 452.95 385.2C452.41 386.93 451.68 388.77 450.4 390.1C449.87 390.64 449.23 391.08 448.5 391.28C447.81 391.46 447.07 391.39 446.37 391.3C439.15 390.39 437.67 386.82 434.66 382.86C433.76 381.67 432.89 380.45 432.06 379.2C430.4 376.71 428.89 374.11 427.54 371.44C422.07 360.56 415.73 344.86 415.68 330.43C415.68 330.43 415.26 322.16 419.9 321.21H419.91Z",
    fill: "#E8E4EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "04_menique_der",
    d: "M480.7 276.71C483.53 283.84 483.69 303.55 483.45 306.02C483.44 306.15 483.43 306.23 483.41 306.26C483.41 306.28 483.41 306.3 483.41 306.32C483.45 306.48 483.5 306.7 483.57 306.96C484.55 310.56 485.74 323.4 491.36 323.4C499.9 323.4 499.52 308.71 499.4 306.34C499.39 306.13 499.38 306.02 499.38 306.02C498.99 301.4 498.34 297.01 497.3 293.25C492.12 274.46 487.25 270.9 483.89 270.83C480.54 270.75 480.69 276.71 480.69 276.71H480.7Z",
    fill: "#E8E4EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "04_anular_der",
    d: "M459.7 269.17L470.53 307.29V307.31C470.53 307.31 473.28 312.81 472.85 317.39C474.18 320.68 476.22 323.37 479.23 323.37C486.9 323.37 484.42 310.58 483.57 306.96C483.5 306.7 483.45 306.48 483.41 306.32C483.41 306.3 483.41 306.28 483.39 306.27C483.36 306.24 483.35 306.18 483.34 306.07C483.34 306.04 483.34 306.02 483.34 306.02C483.31 305.73 483.28 305.21 483.25 304.41C482.88 295.09 470.18 264.47 464.25 263.99C458.32 263.51 459.7 269.17 459.7 269.17V269.17Z",
    fill: "#E8E4EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M464.15 473.42L444 401.59L518.18 387.75L558.3 466.28L464.15 473.42Z",
    fill: "#CA3C66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_386_456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 749.62,
    height: 465.22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep04);
export default __webpack_public_path__ + "static/media/step_04.5f7a6a5b825b32e997d5b7577bc0da2f.svg";
export { ForwardRef as ReactComponent };